const getComparatorCode = () => {
    return `
    const getComparator = (order, orderBy) => {
        const ordered = order === 'desc'
            ? (a, b) => descendingComparator(a, b, orderBy)
            : (a, b) => -descendingComparator(a, b, orderBy);
        return ordered;
    };
    `;
}

export default getComparatorCode;
